<template>
  <div>
    <PageHeader :items="items"/>
    <validation-observer ref="simpleRules">
      <div class="card">
        <div class="card-header">
          <h3>{{ $t("caseInformation") }}</h3>
        </div>
        <div class="card-body">
          <b-row>
            <b-col lg="6" md="6" cols="12" class="mb-1">
              <validation-provider
                  #default="{ errors }"
                  name="Name"
                  rules="required"
              >
                <TextInput
                    v-model="form.name"
                    :label="$t('caseName')"
                    :tooltipMessage="$t('name')"
                    :required="true"
                    :error="errors[0]"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            <b-col lg="6" md="6" cols="12" class="mb-1">
              <div class="form-group">
                <validation-provider
                    #default="{ errors }"
                    name="Case Status"
                    rules="required"
                >
                  <label class="input-label form-label"
                  >{{ $t("status") }}&nbsp;<span style="color: red">*</span>
                  </label>
                  <multiselect
                      v-model="form.status"
                      :options="[
                      'created',
                      'processing',
                      'reviewing',
                      'adjusting',
                      'done'
                    ]"
                      :multiple="false"
                  >
                  </multiselect>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </div>
            </b-col>
            <b-col lg="6" md="6" cols="12" class="mb-1">
              <div class="form-group">
                <validation-provider
                    #default="{ errors }"
                    name="Outcome"
                    rules="required"
                >
                  <label class="input-label form-label"
                  >{{ $t("outcome") }}&nbsp;<span style="color: red">*</span>
                  </label>
                  <multiselect
                      v-model="form.outcome"
                      :options="[
                      'success',
                      'error',
                      'rejected'

                    ]"
                      :multiple="false"
                  >
                  </multiselect>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </div>
            </b-col>
            <b-col lg="6" md="6" cols="12" class="mb-1">
              <div class="form-group">
                <label class="input-label form-label"
                >{{ $t("company") }}
                </label>
                <div class="form-control disabled">
                  {{ companyName }}
                </div>
              </div>
            </b-col>
            <b-col lg="6" md="6" cols="12" class="mb-1">
              <label class="form-label" for="cars">{{ $t("sender") }}</label>
              <div class="form-control disabled">
                <p v-if="caseUser">
                  {{ caseUser.first_name }}
                  <span>{{ caseUser.last_name }}</span>
                </p>
              </div>
            </b-col>
            <b-col lg="6" md="6" cols="12" class="mb-1">
              <label class="form-label" for="cars">{{
                  $t("senderMail")
                }}</label>
              <div class="form-control disabled">
                <p v-if="caseUser">
                  <a :href="'mailto:' + caseUser.email">{{ caseUser.email }}</a>
                </p>
              </div>
            </b-col>
            <b-col lg="6" md="6" cols="12" class="mb-1">
              <label class="form-label" for="cars">{{
                  $t("contactLanguage")
                }}</label>
              <div class="form-control disabled">
                <p>
                  {{ contactLanguage }}
                </p>
              </div>
            </b-col>
            <!-- <b-col v-if="form.files.upper" lg="6" md="6" cols="12" class="mb-1">
              <TextInput
                :type="'number'"
                v-model="form.amountReconstructedUpperTeeth"
                :label="$t('amountOfReconstructedUpperTeeth')"
                :tooltipMessage="$t('amountOfReconstructedUpperTeeth')"
                :required="true"
              />
              <small v-if="showErrorUpper" class="text-danger"
                >The Amount of reconstructed Upper teeth field is
                required</small
              >
            </b-col>
            <b-col v-if="form.files.lower" lg="6" md="6" cols="12" class="mb-1">
              <TextInput
                :type="'number'"
                v-model="form.amountReconstructedLowerTeeth"
                :label="$t('amountOfReconstructedLowerTeeth')"
                :tooltipMessage="$t('amountOfReconstructedLowerTeeth')"
                :required="true"
              />
              <small v-if="showErrorLower" class="text-danger"
                >The Amount of reconstructed Lower teeth field is
                required</small
              >
            </b-col> -->
            <b-col lg="6" md="6" cols="12" class="mb-1" v-if="productName">
              <label class="form-label" for="cars">{{
                  $t("productName")
                }}</label>
              <div class="form-control disabled">
                <p>
                  {{ translatedProductName(productName) }}
                </p>
              </div>
            </b-col>
            <b-col lg="6" md="6" cols="12" class="mb-1">
              <label class="form-label" for="cars">{{
                  $t("modality")
                }}</label>
              <div class="form-control disabled">
                <p>
                  {{ form.modality }}
                </p>
              </div>
            </b-col>
            <b-col lg="6" md="6" cols="12" class="mb-1">
              <label class="form-label" for="cars">{{
                  $t("technology")
                }}</label>
              <div class="form-control disabled">
                <p>
                  {{ technology }}
                </p>
              </div>
            </b-col>
            <b-col lg="6" md="6" cols="12" class="mb-1">
              <validation-provider
                  #default="{ errors }"
                  name="No Of Units"
                  rules="required"
              >
                <TextInput
                    :type="'number'"
                    v-model="form.noOfUnits"
                    :label="$t('noOfUnits')"
                    :tooltipMessage="$t('noOfUnits')"
                    :required="true"
                    :error="errors[0]"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            <b-col lg="3" md="3" cols="12" class="mb-1">
              <div class="checkbox-group d-inline-block mt-2">
                <input
                    id="isApproved"
                    class="checkbox-input"
                    v-model="form.isApproved"
                    type="checkbox"
                    name="isApproved"
                />
                <label class="checkbox-label" for="isApproved">{{
                    $t("approved")
                  }}</label>
              </div>
            </b-col>
            <b-col lg="3" md="3" cols="12" class="mb-1">
              <div class="checkbox-group d-inline-block mt-2">
                <input
                    id="isPaid"
                    :disabled="!$can('backoffice-case-paid-status.edit')"
                    class="checkbox-input"
                    v-model="form.isPaid"
                    type="checkbox"
                    name="isPaid"
                />
                <label class="checkbox-label" for="isPaid">{{
                    $t("isPaid")
                  }}</label>
              </div>
            </b-col>
            <b-col lg="6" md="6" cols="12" class="mb-1">
              <div class="checkbox-group d-inline-block mt-2">
                <input
                    id="jawsCorrectlyAligned"
                    class="checkbox-input"
                    v-model="form.jawsCorrectlyAligned"
                    type="checkbox"
                    name="jawsCorrectlyAligned"
                    disabled
                />
                <label class="checkbox-label" for="jawsCorrectlyAligned">{{
                    $t("wasTheBiteAlsoScanned")
                  }}</label>
              </div>
            </b-col>
            <b-col lg="6" md="6" cols="12" class="mb-1">
              <label class="input-label form-label">
                {{ $t("assignee") }}
              </label>
              <MultiSelectInput
                  v-model="form.assignee"
                  :options="modifiedUsers"
                  :label="'full_name'"
                  trackBy="id"
                  :key="form.assignee"
                  :multiple="false"
                  moduleName="users"
                  :searchParamName="'search_string'"
              >
                <template #option="{ props }">
                  <div>
                    <p>
                      {{ props.option.first_name }} {{ props.option.last_name }}
                    </p>
                  </div>
                </template>
              </MultiSelectInput>
            </b-col>
            <b-col lg="12" md="12" cols="12" class="mb-1">
              <label class="input-label form-label">
                {{ $t("comments") }}
              </label>
              <textarea class="form-control" v-model="form.details"></textarea>
            </b-col>
            <b-col lg="12" md="12" cols="12" class="">
              <label class="input-label form-label">
                {{ $t("commentForNotificationMail") }}
              </label>
              <textarea
                  class="form-control"
                  v-model="form.notificationMailComment"
              ></textarea>
            </b-col>
          </b-row>
          <div class="d-flex align-items-center justify-content-end gap-2 mt-3">
            <b-button
                variant="primary"
                @click="updateCaseData"
                class="d-flex align-items-center gap-1"
                :disabled="isFormInvalid"
                v-b-tooltip.hover
            >
              <feather-icon icon="PlusIcon" size="12"/>
              <span>{{ $t("updateCaseData") }}</span>
            </b-button>
          </div>
        </div>
      </div>
      <b-row>
        <b-col md="12">
          <PreviewOriginalModel
              ref="previewOriginalRef"
              :upperFileId="form.files.upper"
              :lowerFileId="form.files.lower"
              :downloadUpper="form.files.upper_portal_original"
              :downloadLower="form.files.lower_portal_original"
              :biteScanned="form.jawsCorrectlyAligned"
              :upperMatrixIn="
              form.files.upper_matrixLocal && form.files.upper_matrixLocal.reg
            "
              :upperMatrixWorldIn="
              form.files.upper_matrixWorld && form.files.upper_matrixWorld.reg
            "
              :lowerMatrixIn="
              form.files.lower_matrixLocal && form.files.lower_matrixLocal.reg
            "
              :lowerMatrixWorldIn="
              form.files.lower_matrixWorld && form.files.lower_matrixWorld.reg
            "
              @updateCase="updateCase"
              :markedTeeth="markedTeeth"
              :toggledPairs="toggledPairs"
              :productName="productName"
              :teethFile="teethFile"
              :isFormInvalid="isFormInvalid"
          />
        </b-col>
      </b-row>
      <div v-if="productName=='dentaBridge'" class="card">
        <div class="card-header">
          <h3>{{ $t("dentaBridgeSpecifications") }}</h3>
        </div>
        <div class="card-body">
          <b-row>
            <b-col cols="4">
              <TextInput :label="$t('material')" :value="getMaterialName(material)" :isReadonly="true"/>
            </b-col>

            <b-col cols="4">
              <TextInput :label="$t('cementGap')" :value="dentaBridgeSpecifications.cementGap" :isReadonly="true"/>
            </b-col>
            <b-col cols="4">
              <TextInput :label="$t('startCementGap')"
                         :value="dentaBridgeSpecifications.startCementGap != null ? Number(dentaBridgeSpecifications.startCementGap).toFixed(2) : ''"
                         :isReadonly="true"/>
            </b-col>
            <b-col cols="4">
              <TextInput :label="$t('edgeThickness')"
                         :value="dentaBridgeSpecifications.edgeThickness != null ? Number(dentaBridgeSpecifications.edgeThickness).toFixed(2) : ''"
                         :isReadonly="true"/>
            </b-col>
            <b-col cols="4">
              <TextInput :label="$t('minimumThickness')"
                         :value="dentaBridgeSpecifications.minimumThickness != null ? Number(dentaBridgeSpecifications.minimumThickness).toFixed(2) : ''"
                         :isReadonly="true"/>
            </b-col>
            <b-col v-if="dentaBridgeSpecifications.manufacturingMethod === 'milling'" cols="4">
              <TextInput :label="$t('millingHeadDiameter')" :value="dentaBridgeSpecifications.millingHeadDiameter"
                         :isReadonly="true"/>
            </b-col>
            <b-col cols="4">
              <TextInput :label="$t('occlusalContactStrength')"
                         :value="dentaBridgeSpecifications.occlusalContactStrength != null ? Number(dentaBridgeSpecifications.occlusalContactStrength).toFixed(3) : ''"
                         :isReadonly="true"/>
            </b-col>
            <b-col cols="4">
              <TextInput :label="$t('proximalContactStrength')"
                         :value="dentaBridgeSpecifications.proximalContactStrength != null ? Number(dentaBridgeSpecifications.proximalContactStrength).toFixed(3) : ''"
                         :isReadonly="true"/>
            </b-col>
            <b-col cols="4">
              <TextInput :label="$t('gingivalContactStrength')"
                         :value="dentaBridgeSpecifications.gingivalContactStrength != null ? Number(dentaBridgeSpecifications.gingivalContactStrength).toFixed(3) : ''"
                         :isReadonly="true"/>
            </b-col>
            <!-- <b-col cols="4"> <SegmentedRadio v-model="dentaBridgeSpecifications.mode" :label="$t('millingOrPrinting')"  :options="[$t('left'), $t('right')]" :readonly="true" /> </b-col> -->
            <b-col cols="4">
              <SegmentedRadio ref="manufacturingMethodRadio" v-model="dentaBridgeSpecifications.manufacturingMethod"
                              :label="$t('manufacturingMethod')" :options="[$t('milling'),$t('printing')]"
                              :optionValues="['milling', 'printing']" :readonly="true"/>
            </b-col>
            <!-- <b-col cols="4" v-if="dentaBridgeSpecifications.manufacturingMethod === 'milling'">
              <TextInput :label="$t('millingHeadSize')" :value="dentaBridgeSpecifications.millingHeadSize" :isReadonly="true" />
            </b-col> -->
          </b-row>
        </div>
      </div>
      <div class="card">
        <div class="card-header">
          <h3>{{ $t("caseFiles") }}</h3>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="card-header">
              <h3 class="card-title">
                {{ $t("constructionInfo") }}
              </h3>
            </div>
            <div class="card-body">
              <div class="upload-file-list">
                <ul>
                  <li v-if="constructionFile && constructionFile.fileId">
                    <h4>
                      Construction Info file
                    </h4>
                    <div class="action-dropdown">
                      <div class="d-flex justify-content-end gap-1">
                        <div
                            class="d-flex align-items-center justify-content-center"
                            style="width: 32px; height: 32px; cursor: pointer"
                            @click="downloadFiles([constructionFile.fileId])"
                        >
                          <feather-icon size="16" icon="DownloadIcon"/>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
              <button
                  @click="openUploadModal('construction', 'construction')"
                  class="btn btn-secondary mt-2"
              >
                <feather-icon size="16" icon="UploadIcon" class="stroke-icon"/>
                <span>{{ $t("uploadConstructionInfo") }}</span>
              </button>
            </div>
          </div>
        </div>
        <div class="row">
          <div
              v-if="form.files.upper_portal_original || form.files.upper_portal"
              class="col-md-6"
          >
            <div class="card-header">
              <h3 class="card-title">
                {{ $t("upperJaw") }}
                <span class="text-danger" v-if="isUpperDeleted">DELETED</span>
              </h3>
            </div>
            <div class="card-body" v-if="isUpperDeleted">
              <div class="d-flex align-items-center justify-content-between mb-1">
                <b-button
                    variant="primary"
                    @click="restoreJaw('upper')"
                    class="d-flex align-items-center w-40"
                >
                  <span>{{ $t("restoreJaw") }}</span>
                </b-button>
              </div>
            </div>
            <div class="card-body" v-else>
              <div
                  class="d-flex align-items-center justify-content-between mb-1"
                  v-if="showDeleteJaws"
              >
                <b-button
                    variant="primary"
                    @click="deleteJaw('upper')"
                    class="d-flex align-items-center w-40"
                >
                  <span>{{ $t("deleteUpperJaw") }}</span>
                </b-button>
              </div>
              <div
                  class="d-flex align-items-center justify-content-between mb-1"
              >
                <h4 class="m-0">{{ $t("upperResults") }}</h4>
              </div>
              <div class="upload-file-list">
                <ul>
                  <li
                      v-for="(fileItem, index) in upperJawFiles"
                      :key="index"
                      v-if="getFileValue(fileItem.source, fileItem.key)"
                  >
                    <h4>
                      {{
                        fileItem.label
                      }}<span v-if="fileItem.key === 'upper_rotated'">
                        {{ isUpperResultActive ? "ACTIVE" : "INACTIVE" }}
                      </span>
                    </h4>
                    <div class="action-dropdown">
                      <div class="d-flex justify-content-end gap-1">
                        <div
                            class="d-flex align-items-center justify-content-center"
                            style="width: 32px; height: 32px; cursor: pointer"
                            @click="
                            handlePreviewResultClick(
                              [getFileValue(fileItem.source, fileItem.key)],
                              'Upper'
                            )
                          "
                        >
                          <feather-icon size="16" icon="EyeIcon"/>
                        </div>
                        <div
                            class="d-flex align-items-center justify-content-center"
                            style="width: 32px; height: 32px; cursor: pointer"
                            @click="
                            downloadFiles([
                              getFileValue(fileItem.source, fileItem.key),
                            ])
                          "
                        >
                          <feather-icon size="16" icon="DownloadIcon"/>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li
                      v-for="(fileItem, index) in upperCaseResults"
                      :key="index"
                  >
                    <h4>
                      {{ fileItem.fileName }}
                      {{ fileItem.isActive ? "ACTIVE" : "INACTIVE" }}
                    </h4>
                    <div class="action-dropdown">
                      <b-nav-item-dropdown
                          right
                          toggle-class="d-flex align-items-center"
                      >
                        <template #button-content>
                          <div>
                            <ElementIcon icon="barVerticalIcon"/>
                          </div>
                        </template>
                        <b-dropdown-item
                            @click="
                            handlePreviewResultClick([fileItem.fileId], 'Upper')
                          "
                            link-class="d-flex align-items-center gap-2"
                        >
                          <feather-icon size="16" icon="EyeIcon"/>
                          <span>{{ $t("preview") }}</span>
                        </b-dropdown-item>
                        <b-dropdown-item
                            @click="downloadFiles([fileItem.fileId])"
                            link-class="d-flex align-items-center gap-2"
                        >
                          <feather-icon size="16" icon="DownloadIcon"/>
                          <span>{{ $t("download") }}</span>
                        </b-dropdown-item>
                        <b-dropdown-item
                            @click="updateStatus(fileItem.id, fileItem.isActive)"
                            link-class="d-flex align-items-center gap-2"
                        >
                          <feather-icon size="16" icon="EditIcon"/>
                          <span>{{
                              fileItem.isActive ? "Inactive" : "Active"
                            }}</span>
                        </b-dropdown-item>
                        <b-dropdown-item
                            @click="destroy([fileItem.id], 'Upper Case Result')"
                            link-class="d-flex align-items-center gap-2"
                        >
                          <feather-icon size="16" icon="TrashIcon"/>
                          <span>{{ $t("delete") }}</span>
                        </b-dropdown-item>
                        <b-dropdown-item
                            v-if="!isUpperDeleted && !isDentaWaxOrTemp(productName)"
                            @click="replaceResult($event, fileItem)"
                            link-class="d-flex align-items-center gap-2"
                        >
                          <feather-icon size="16" icon="UploadIcon"/>
                          <span>Upload replacement</span>
                        </b-dropdown-item>
                      </b-nav-item-dropdown>
                    </div>
                  </li>
                </ul>
              </div>
              <button
                v-if="!isUpperDeleted && isDentaWaxOrTemp(productName)"
                class="btn btn-secondary mt-2"
                @click="openUploadModal('upper', 'result')">
                  <feather-icon size="16" icon="UploadIcon" class="stroke-icon" />
                  <span>{{ $t("uploadUpperResults") }}</span>
              </button>
            </div>
          </div>
          <div
              v-if="form.files.lower_portal_original || form.files.lower_portal"
              class="col-md-6"
          >
            <div class="card-header">
              <h3 class="card-title">
                {{ $t("lowerJaw") }}
                <span class="text-danger" v-if="isLowerDeleted">DELETED</span>
              </h3>
            </div>
            <div class="card-body" v-if="isLowerDeleted">
              <div class="d-flex align-items-center justify-content-between mb-1">
                <b-button
                    variant="primary"
                    @click="restoreJaw('lower')"
                    class="d-flex align-items-center w-40"
                >
                  <span>{{ $t("restoreJaw") }}</span>
                </b-button>
              </div>
            </div>
            <div class="card-body" v-else>
              <div
                  class="d-flex align-items-center justify-content-between mb-1"
                  v-if="showDeleteJaws"
              >
                <b-button
                    variant="primary"
                    @click="deleteJaw('lower')"
                    class="d-flex align-items-center w-40"
                >
                  <span>{{ $t("deleteLowerJaw") }}</span>
                </b-button>
              </div>
              <div
                  class="d-flex align-items-center justify-content-between mb-1"
              >
                <h4 class="m-0">{{ $t("lowerResults") }}</h4>
              </div>
              <div class="upload-file-list">
                <ul>
                  <li
                      v-for="(fileItem, index) in lowerJawFiles"
                      :key="index"
                      v-if="getFileValue(fileItem.source, fileItem.key)"
                  >
                    <h4>
                      {{ fileItem.label }}
                      <span v-if="fileItem.key === 'lower_rotated'">
                        {{ isLowerResultActive ? "ACTIVE" : "INACTIVE" }}
                      </span>
                    </h4>
                    <div class="action-dropdown">
                      <div class="d-flex justify-content-end gap-1">
                        <div
                            class="d-flex align-items-center justify-content-center"
                            style="width: 32px; height: 32px; cursor: pointer"
                            @click="
                            handlePreviewResultClick(
                              [getFileValue(fileItem.source, fileItem.key)],
                              'Lower'
                            )
                          "
                        >
                          <feather-icon size="16" icon="EyeIcon"/>
                        </div>
                        <div
                            class="d-flex align-items-center justify-content-center"
                            style="width: 32px; height: 32px; cursor: pointer"
                            @click="
                            downloadFiles([
                              getFileValue(fileItem.source, fileItem.key),
                            ])
                          "
                        >
                          <feather-icon size="16" icon="DownloadIcon"/>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li
                      v-for="(fileItem, index) in lowerCaseResults"
                      :key="index"
                  >
                    <h4>
                      {{ fileItem.fileName }}
                      {{ fileItem.isActive ? "ACTIVE" : "INACTIVE" }}
                    </h4>
                    <div class="action-dropdown">
                      <b-nav-item-dropdown
                          right
                          toggle-class="d-flex align-items-center"
                      >
                        <template #button-content>
                          <div>
                            <ElementIcon icon="barVerticalIcon"/>
                          </div>
                        </template>
                        <b-dropdown-item
                            @click="
                            handlePreviewResultClick([fileItem.fileId], 'Lower')
                          "
                            link-class="d-flex align-items-center gap-2"
                        >
                          <feather-icon size="16" icon="EyeIcon"/>
                          <span>{{ $t("preview") }}</span>
                        </b-dropdown-item>
                        <b-dropdown-item
                            @click="downloadFiles([fileItem.fileId])"
                            link-class="d-flex align-items-center gap-2"
                        >
                          <feather-icon size="16" icon="DownloadIcon"/>
                          <span>{{ $t("download") }}</span>
                        </b-dropdown-item>
                        <b-dropdown-item
                            @click="updateStatus(fileItem.id, fileItem.isActive)"
                            link-class="d-flex align-items-center gap-2"
                        >
                          <feather-icon size="16" icon="EditIcon"/>
                          <span>{{
                              fileItem.isActive ? "Inactive" : "Active"
                            }}</span>
                        </b-dropdown-item>
                        <b-dropdown-item
                            @click="destroy([fileItem.id], 'Lower Case Result')"
                            link-class="d-flex align-items-center gap-2"
                        >
                          <feather-icon size="16" icon="TrashIcon"/>
                          <span>{{ $t("delete") }}</span>
                        </b-dropdown-item>
                        <b-dropdown-item
                            v-if="!isLowerDeleted && !isDentaWaxOrTemp(productName)"
                            @click="replaceResult($event, fileItem)"
                            link-class="d-flex align-items-center gap-2"
                        >
                          <feather-icon size="16" icon="UploadIcon"/>
                          <span>Upload replacement</span>
                        </b-dropdown-item>
                      </b-nav-item-dropdown>
                    </div>
                  </li>
                </ul>
              </div>
              <button
                v-if="!isLowerDeleted && isDentaWaxOrTemp(productName)"
                class="btn btn-secondary mt-2"
                @click="openUploadModal('lower', 'result')">
                  <feather-icon size="16" icon="UploadIcon" class="stroke-icon" />
                  <span>{{ $t("uploadLowerResults") }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="card">
        <Logs ref="caseLogs"/>
      </div>
      <div class="d-flex align-items-center justify-content-end gap-2">
        <router-link
            to="/my-cases"
            class="d-flex align-items-center gap-1 btn btn-secondary"
        >
          <feather-icon icon="XIcon" size="12"/>
          <span>{{ $t("cancel") }}</span>
        </router-link>
        <b-button
            variant="primary"
            @click="sendMail()"
            class="d-flex align-items-center gap-1"
        >
          <feather-icon icon="PlusIcon" size="12"/>
          <span>{{ $t("sendApprovedNotificationMail") }}</span>
        </b-button>
      </div>
      <div class="c-modal" v-show="showPreviewModal">
        <div class="c-modal-content">
          <div class="c-modal-header">
            <h3>{{ $t(previewJawType === 'upper' ? 'previewUpperJaw' : 'previewLowerJaw') }}</h3>
            <div class="x-icon" @click="closePreviewResultModal">
              <feather-icon size="16" icon="XIcon"/>
            </div>
          </div>
          <div class="c-modal-body">
            <PreviewResultModel v-if="showPreviewModal" :results="file"/>
          </div>
        </div>
      </div>
      <b-modal
          id="edit-tag-modal"
          v-model="showMultipleUploadModal"
          :title="modalTitle"
          centered
          size="md"
          hide-footer
      >
        <!-- Upper Jaw Upload -->
        <div v-if="modalType == 'upper'" class="form-group mb-1">
          <label class="input-label form-label">
            {{ $t("upperJawResult") }}
          </label>
          <input
              type="file"
              multiple
              accept=".stl, .obj"
              class="form-control"
              @change="handleFileChange($event, 'upper')"
          />
        </div>

        <!-- Upper Reset Rotation Checkbox (only shown if upper file uploaded) -->
        <div
            v-if="upperFiles.length > 0 && modalType == 'upper'"
            class="form-group mb-1 mt-1"
        >
          <label class="input-label form-label">{{
              $t("resetUpperJawRotation")
            }}</label>
          <div>
            <div class="form-check form-check-inline">
              <input
                  class="form-check-input"
                  type="radio"
                  :id="'upperYes'"
                  value="yes"
                  v-model="resetRotation.upper"
                  required
              />
              <label class="form-check-label" :for="'upperYes'">{{
                  $t("yes")
                }}</label>
            </div>
            <div class="form-check form-check-inline">
              <input
                  class="form-check-input"
                  type="radio"
                  :id="'upperNo'"
                  value="no"
                  v-model="resetRotation.upper"
                  required
              />
              <label class="form-check-label" :for="'upperNo'">{{
                  $t("no")
                }}</label>
            </div>
          </div>
        </div>

        <!-- Lower Jaw Upload -->
        <div v-if="modalType == 'lower'" class="form-group">
          <label class="input-label form-label">
            {{ $t("lowerJawResult") }}
          </label>
          <input
              type="file"
              multiple
              accept=".stl, .obj"
              class="form-control"
              @change="handleFileChange($event, 'lower')"
          />
        </div>
        <div v-if="modalType == 'construction'" class="form-group mb-1">
          <label class="input-label form-label">
            {{ $t("uploadConstructionInfo") }}
          </label>
          <input
              type="file"
              class="form-control"
              accept=".constructionInfo,.xml,.text,.txt"
              @change="handleConstructionInfoFileChange"
          />
        </div>

        <!-- Lower Reset Rotation Checkbox (only shown if lower file uploaded) -->
        <div
            v-if="lowerFiles.length > 0 && modalType == 'lower'"
            class="form-group mb-1 mt-1"
        >
          <label class="input-label form-label">{{
              $t("resetLowerJawRotation")
            }}</label>
          <div>
            <div class="form-check form-check-inline">
              <input
                  class="form-check-input"
                  type="radio"
                  :id="'lowerYes'"
                  value="yes"
                  v-model="resetRotation.lower"
                  required
              />
              <label class="form-check-label" :for="'lowerYes'">{{
                  $t("yes")
                }}</label>
            </div>
            <div class="form-check form-check-inline">
              <input
                  class="form-check-input"
                  type="radio"
                  :id="'lowerNo'"
                  value="no"
                  v-model="resetRotation.lower"
                  required
              />
              <label class="form-check-label" :for="'lowerNo'">{{
                  $t("no")
                }}</label>
            </div>
          </div>
        </div>

        <div class="d-flex align-items-center justify-content-end mt-2">
          <button
              @click="showMultipleUploadModal = false"
              class="btn btn-secondary mr-1"
          >
            {{ $t("cancel") }}
          </button>
          <button @click="saveMultiple()" class="btn btn-primary">
            {{ $t("save") }}
          </button>
        </div>
      </b-modal>
      <div class="img-prev-modal" v-if="isPrevShow">
        <div class="modal-content">
          <img class="img-prev" :src="isImgPreview" alt=""/>
          <div class="close-modal" @click="closeImgPrev">
            <feather-icon size="18" icon="XIcon"/>
          </div>
        </div>
      </div>

      <CaseFeedbackModal
          :show="showFeedbackModal"
          @update:show="showFeedbackModal = $event"
          @submit="handleFeedbackSubmit"
      />
    </validation-observer>
  </div>
</template>

<script>
import * as THREE from "three";
import TextInput from "@/components/TextInput.vue";
import PageHeader from "@/components/PageHeader.vue";
import Multiselect from "vue-multiselect";
import fileHandlerMixin from "@/mixins/fileHandlerMixin";
import materialNameMixin from "@/mixins/materialNameMixin";
import {ValidationProvider, ValidationObserver} from "vee-validate";
import {mapGetters} from "vuex";
import {VueEditor} from "vue2-quill-editor";
import {required, email} from "@validations";
import MultiSelectInput from "@/components/MultiSelectInput.vue";
import StarRating from "@/components/elements/StarRating.vue";
import PreviewResultModel from "@/components/PreviewResultModel.vue";
import FileService from "@/services/file.service";
import PreviewOriginalModel from "./components/PreviewOriginalModel.vue";
import Logs from "./components/Logs.vue";
import UploadHistory from "./components/UploadHistory.vue";
import ElementIcon from "@/components/elements/Icon.vue";
import CaseFeedbackModal from "@/components/CaseFeedbackModal.vue";
import SegmentedRadio from "@/components/elements/SegmentedRadio.vue";
import productTranslatorMixin from "@/mixins/productTranslator";

export default {
  components: {
    TextInput,
    PageHeader,
    Multiselect,
    ValidationProvider,
    ValidationObserver,
    VueEditor,
    StarRating,
    PreviewResultModel,
    PreviewOriginalModel,
    Logs,
    UploadHistory,
    ElementIcon,
    CaseFeedbackModal,
    MultiSelectInput,
    SegmentedRadio,
  },
  mixins: [fileHandlerMixin, materialNameMixin, productTranslatorMixin],
  computed: {
    ...mapGetters("globalConfiguration", ["configuration"]),
    ...mapGetters("caseLists"),
    ...mapGetters("auth", ["user"]),
    ...mapGetters("users", ["users"]),
    modifiedUsers() {
      return (this.users || []).map((user) => ({
        ...user,
        full_name: `${user.first_name} ${user.last_name}`,
      }));
    },
    showDeleteJaws() {
      const r = this.form.results;
      return (
          (r["upper"] || r["upper_rotated"]) && (r["lower"] || r["lower_rotated"])
      );
    },
    items() {
      return [
        {
          text: "Dental Twin",
          to: "/home",
        },
        {
          text: this.$t("cases"),
          to: "/my-cases",
        },
        {
          html: `${this.$t("edit")}${this.form.name ? ' <strong>[' + this.form.name + ']</strong>' : ''}`,
          active: true,
        },
      ];
    },
    isFormInvalid() {
      return (
          // (this.form.files.upper && !this.form.amountReconstructedUpperTeeth) ||
          // (this.form.files.lower && !this.form.amountReconstructedLowerTeeth) ||
          !this.form.name || !this.form.status || !this.form.noOfUnits
      );
    },
  },
  data() {
    return {
      modalTitle: "",
      uploadType: "",
      upperFiles: [],
      lowerFiles: [],
      isUpperResultActive: true,
      isLowerResultActive: true,
      isUpperDeleted: false,
      isLowerDeleted: false,
      modalType: "",
      resetRotation: {
        upper: "no",
        lower: "no",
      },
      upperJawFiles: [
        {
          key: "upper_portal_original",
          label: "original.stl",
          source: "files",
        },
        {
          key: "upper_portal",
          label: "original registered.stl",
          source: "files",
        },
        {key: "upper", label: "original used for AI.stl", source: "files"},
        {key: "upper_rotated", label: "result.stl", source: "results"},
        {key: "upper", label: "result deregistered.stl", source: "results"},
      ],
      lowerJawFiles: [
        {
          key: "lower_portal_original",
          label: "original.stl",
          source: "files",
        },
        {
          key: "lower_portal",
          label: "original registered.stl",
          source: "files",
        },
        {key: "lower", label: "original used for AI.stl", source: "files"},
        {key: "lower_rotated", label: "result.stl", source: "results"},
        {key: "lower", label: "result deregistered.stl", source: "results"},
      ],
      resultsToSave: [],
      markedTeeth: [],
      toggledPairs: [],
      upperCaseResults: [],
      lowerCaseResults: [],
      technology: "",
      form: {
        name: "",
        details: "",
        status: "",
        outcome: "",
        results: {},
        ratings: {},
        files: {},
        modality: "",
        notificationMailComment: "",
        isApproved: false,
        jawsCorrectlyAligned: false,
        isPaid: false,
        noOfUnits: "",
        assignee: null,
        // amountReconstructedUpperTeeth: "",
        // amountReconstructedLowerTeeth: "",
      },
      constructionFile: null,
      isDownloadingFile: false,
      isPrevShow: false,
      isImgPreview: "",
      productName: "",
      contactLanguage: "",
      teethFile: "",
      material: {},
      dentaBridgeSpecifications: {
        material: "",
        cementGap: 0,
        startCementGap: 0,
        edgeThickness: 0,
        minimumThickness: 0,
        millingHeadDiameter: 0,
        occlusalContactStrength: 0,
        proximalContactStrength: 0,
        gingivalContactStrength: 0,
        mode: "left",
        manufacturingMethod: "milling",
        // millingHeadSize: 1,
      },

      showMultipleUploadModal: false,
      isPaid: false,
      caseUser: {},
      idleTimer: null,
      idleTimeout: 15 * 60 * 1000,
      // costsPerUpperJaw: "",
      // maximumOverallCosts: "",
      companyName: "",
      // costsPerLowerJaw: "",
      showPreviewModal: false,
      file: null,
      previewJawType: "",
      renderOriginalComponent: false,
      showErrorUpper: false,
      showErrorLower: false,
      showError: false,
      caseId: "",
      showFeedbackModal: false,
      originalIsApproved: false,
      constructionInfoFile: null,
    };
  },
  watch: {
    "form.isApproved"(newValue, oldValue) {

      const newBool = Boolean(newValue);
      const oldBool = Boolean(oldValue);
      const originalBool = Boolean(this.originalIsApproved);

      if (newBool === true && oldBool === false && !originalBool) {
        this.showFeedbackModal = true;
      }
    },
  },
  async mounted() {
    // this.boundBeforeUnload = () => {
    //   // Trigger async unlockCase *without waiting for it*
    //   this.unlockCase();
    // };
    this.caseId = this.$route.params.id;
    // await this.lockCase();
    await this.loadUsers();
    await this.loadItems();
    await this.loadResults();

    this.$store.commit("showLoader", false);

    // Start idle timer
    this.resetIdleTimer();

    // Listen for user activity
    window.addEventListener("mousemove", this.activityHandler);
    window.addEventListener("keydown", this.activityHandler);
    window.addEventListener("click", this.activityHandler);
    window.addEventListener("scroll", this.activityHandler);

    window.addEventListener("beforeunload", this.boundBeforeUnload);
  },
  beforeDestroy() {
    clearTimeout(this.idleTimer);

    // Cleanup listeners
    window.removeEventListener("mousemove", this.activityHandler);
    window.removeEventListener("keydown", this.activityHandler);
    window.removeEventListener("click", this.activityHandler);
    window.removeEventListener("scroll", this.activityHandler);

    window.removeEventListener("beforeunload", this.boundBeforeUnload);
  },
  methods: {
    async loadUsers() {
      if (!this.users || !this.users.length) {
        await this.$store.dispatch("users/list");
      }
    },
    closeImgPrev() {
      if (this.isImgPreview) {
        try {
          URL.revokeObjectURL(this.isImgPreview);
        } catch (e) {
        }
      }
      this.isImgPreview = "";
      this.isPrevShow = false;
    },
    openUploadModal(type, uploadType) {
      this.modalType = type;
      this.uploadType = uploadType;
      if (this.uploadType === "construction") {
        this.modalTitle = this.$t("uploadConstructionInfo");
        this.constructionInfoFile = null;
      } else this.modalTitle = this.$t("uploadMultipleResults");

      this.showMultipleUploadModal = true;
    },
    getFileValue(source, key) {
      return this.form[source] && this.form[source][key]
          ? this.form[source][key]
          : null;
    },
    handleFileChange(event, jawType) {
      const files = Array.from(event.target.files);
      const mapping = {
        upper: "upperFiles",
        lower: "lowerFiles",
      };

      if (mapping[jawType]) {
        this[mapping[jawType]] = files;
      }
    },
    async destroy(id, type) {
      const confirmed = await this.showConfirmationDialog({
        title: this.$t("doYouWantToDeleteThisRecord"),
        subText: this.$t("yesDeleteIt"),
      });

      if (confirmed) {
        try {
          this.$store.commit("showLoader", true);
          await this.$store.dispatch("caseLists/destroyResult", {id, payload: {type: type}});
          this.loadResults();
          this.$refs.caseLogs.loadItems();
        } catch (e) {
          console.error("api error ___", e);
        } finally {
          this.$store.commit("showLoader", false);
        }
      }
    },
    async loadResults() {
      try {
        this.$store.commit("showLoader", true);
        let response = await this.$store.dispatch(
            "caseLists/getMultipleResults",
            {
              id: this.$route.params.id,
            }
        );
        const responseData = response?.data?.data ?? [];

        function fdiIsUpper(code) {
          if (!/^\d{2}$/.test(code)) return false;
          const quadrant = Number(code[0]);
          return (quadrant === 1 || quadrant === 2);
        }

        function fdiIsLower(code) {
          if (!/^\d{2}$/.test(code)) return false;
          const quadrant = Number(code[0]);
          return (quadrant === 3 || quadrant === 4);
        }

        this.upperCaseResults = responseData
            .filter((item) => item.type === "Upper Jaw Result" || fdiIsUpper(item.type.substring(0, 2)));

        this.lowerCaseResults = responseData
            .filter((item) => item.type === "Lower Jaw Result" || fdiIsLower(item.type.substring(0, 2)));
      } catch (e) {
        console.error("api error ___", e);
      } finally {
        this.$store.commit("showLoader", false);
      }
    },
    async sendMail() {
      try {
        this.$store.commit("showLoader", true);
        await this.$store
            .dispatch("caseLists/sendMail", this.$route.params.id)
            .finally(() => {
              this.$store.commit("showLoader", false);
            });
      } catch (e) {
        this.$store.commit("showLoader", false);
        console.error("api error", e);
      }
    },
    async saveMultiple() {
      if (this.modalType === "construction") {
        await this.saveConstructionInfoFile();
        return;
      }

      this.$store.commit("showLoader", true);
      this.resultsToSave = []; // Reset before collecting

      const uploads = [];

      for (const file of this.upperFiles) {
        uploads.push(this.uploadFile(file, "upper", "results"));
      }
      for (const file of this.lowerFiles) {
        uploads.push(this.uploadFile(file, "lower", "results"));
      }

      try {
        await Promise.all(uploads);

        // Now dispatch all at once
        const payload = {
          caseId: this.$route.params.id,
          results: this.resultsToSave,
          resetRotation: this.resetRotation,
        };

        await this.$store.dispatch("caseLists/saveMultipleResults", payload);
      } catch (error) {
        console.error("Upload failed:", error);
      } finally {
        this.$store.commit("showLoader", false);
        this.resultsToSave = [];
        this.resetRotation = {
          upper: "no",
          lower: "no",
        };
        this.upperFiles = [];
        this.lowerFiles = [];
        this.showMultipleUploadModal = false;

        this.$nextTick(() => {
          this.loadResults();
          this.$refs.caseLogs.loadItems();
        });
      }
    },
    async replaceResult(event, oldResult) {
      let file = await new Promise(resolve => {
        let input = document.createElement("input");
        input.type = "file";
        input.accept = ".stl,.obj";

        input.onchange = e => {
          resolve(e.target.files[0]);
        };

        input.click();
      });

      if (!file) return;

      this.$store.commit("showLoader", true);
      try {
        const response = await FileService.uploadFile(
          file,
          {visibility: 1},
          0,
          0.33,
          this.productName === "dentaBridge"
        );
        const uploadedFile = response?.data?.[0];

        if (!uploadedFile?.id) {
          throw new Error("The replacement file could not be uploaded.");
        }

        const type = oldResult.type;

        await this.$store.dispatch("caseLists/saveMultipleResults", {
          caseId: this.$route.params.id,
          results: [{
            type,
            file_id: uploadedFile.id,
            file_name: uploadedFile.originalFileName,
          }],
          resetRotation: {
            upper: "no",
            lower: "no",
          },
        });

        if (oldResult.isActive) {
          await this.$store.dispatch("caseLists/updateResultStatus", {
            resultId: oldResult.id,
          });
        }

        await this.loadResults();
        this.$refs.caseLogs?.loadItems?.();
      } catch (error) {
        console.error("Result replacement failed:", error);
      } finally {
        this.$store.commit("showLoader", false);
      }
    },
    async saveConstructionInfoFile() {
      if (!this.constructionInfoFile) {
        this.showMultipleUploadModal = false;
        return;
      }

      this.$store.commit("showLoader", true);
      try {
        let data = new FormData();
        data.append("file", this.constructionInfoFile);
        data.append("caseId", this.$route.params.id);

        await this.$store.dispatch("caseLists/uploadConstructionInfoFile", {
          data,
        });
        this.constructionInfoFile = null;
        await this.loadItems();
        if (this.$refs.caseLogs) {
          this.$refs.caseLogs.loadItems();
        }
      } catch (error) {
        console.error("Upload failed:", error);
      } finally {
        this.$store.commit("showLoader", false);
        this.showMultipleUploadModal = false;
      }
    },
    uploadFile(file, jawType, fileType) {
      this.showMultipleUploadModal = false;
      return FileService.uploadFile(file, {visibility: 1}, 0, 0.33, this.productName === "dentaBridge").then(
          (response) => {
            const fileId = response?.data?.[0]?.id;
            const fileName = response?.data?.[0]?.originalFileName;
            if (!fileId) return;

            let result;

            if (fileType === "results") {
              result = {
                type:
                    jawType === "upper" ? "Upper Jaw Result" : "Lower Jaw Result",
                file_id: fileId,
                file_name: fileName,
              };
            }

            // Store the result so that you can batch send them all later
            this.resultsToSave.push(result);
          }
      );
    },
    resetIdleTimer() {
      clearTimeout(this.idleTimer);
      this.idleTimer = setTimeout(this.handleIdleTimeout, this.idleTimeout);
    },
    handleIdleTimeout() {
      // You can also unlock the case here if needed
      this.$router.push("/my-cases"); // redirect to case list
    },
    activityHandler() {
      this.resetIdleTimer();
    },
    // async lockCase() {
    //   try {
    //     await this.$store
    //      .dispatch("caseLists/lockCase", {
    //        id: this.$route.params.id
    //      })
    //      .then(() => {
    //        this.isLocked = false;
    //      })
    //      .catch((error) => {
    //        this.isLocked = true;
    //      });
    //   } catch (error) {
    //     console.error("Error locking case:", error);
    //   }
    // },
    // async unlockCase() {
    //   if (this.caseId) {
    //     await this.$store.dispatch("caseLists/unlockCase", this.caseId);
    //   }
    // },
    async replicateCase() {
      const payload = {
        caseId: this.$route.params.id,
        extensions: [{id: "opg-to-3d"}],
        newCase: false,
      };

      await this.$store
          .dispatch("caseLists/replicateCase", payload)
          .finally(() => {
            this.loadItems();
          });
    },
    async updateStatus(id, status) {
      const title =
          status === true
              ? this.$t("doYouWantToActiveThisRecord")
              : this.$t("doYouWantToInactiveThisRecord");

      const confirmed = await this.showConfirmationDialog({
        title: title,
        subText: this.$t("yesUpdateIt"),
      });

      if (confirmed) {
        this.$store.commit("showLoader", true);
        await this.$store
            .dispatch("caseLists/updateResultStatus", {
              resultId: id,
            })
            .finally(() => {
              this.$store.commit("showLoader", false);
              this.loadResults();
            });
      }
    },
    async loadItems() {
      await this.$store
          .dispatch("caseLists/show", this.$route.params.id)
          .then(async (res) => {
            var response = res?.data?.data;
            this.companyName = response?.companyName ?? "-";
            this.form.name = response?.name ?? "";
            this.form.noOfUnits = response?.noOfUnits ?? "";
            this.form.notificationMailComment =
                response?.notificationMailComment ?? "";
            this.contactLanguage = response?.contactLanguage ?? "";
            this.productName = response?.productName ?? "";
            this.material = response?.material ?? {};
            this.teethFile = response?.teethFile ?? "";
            this.dentaBridgeSpecifications = response?.dentaBridgeSpecifications ?? {
              material: "",
              cementGap: 0,
              startCementGap: 0,
              edgeThickness: 0,
              minimumThickness: 0,
              millingHeadDiameter: 0,
              occlusalContactStrength: 0,
              proximalContactStrength: 0,
              gingivalContactStrength: 0,
              mode: "left",
              manufacturingMethod: "milling",
            };

            // this.form.amountReconstructedUpperTeeth =
            //   response?.amountReconstructedUpperTeeth;
            // this.form.amountReconstructedLowerTeeth =
            //   response?.amountReconstructedLowerTeeth;
            this.form.details = response?.details ?? "";
            this.form.status = response?.status ?? "";
            this.form.outcome = response?.outcome ?? "";
            this.form.modality = response?.modality ?? "";
            this.technology = response?.technology ?? "";

            this.form.results = response?.results ?? {};
            this.form.ratings = response?.ratings ?? {};
            this.form.files = response?.files ?? {};
            this.constructionFile = response?.constructioninfoFile ?? null;
            this.form.isApproved = response?.isApproved;
            this.originalIsApproved = Boolean(response?.isApproved);
            this.isUpperDeleted = response?.isUpperDeleted;
            this.isLowerDeleted = response?.isLowerDeleted;
            this.form.jawsCorrectlyAligned = response?.jawsCorrectlyAligned;
            this.form.isPaid = response?.isPaid;
            this.markedTeeth = response?.markedTeeth?.selectedTeeth ?? [];
            this.toggledPairs = response?.markedTeeth?.connectedTeeth ?? [];
            this.isPaid = response?.isPaid;
            if (response?.assignee) {
              this.$store.dispatch("users/show", {
                id: response?.assignee,
              }).then(response => {
                this.form.assignee = response?.data;
                this.form.assignee.full_name = `${this.form.assignee.first_name} ${this.form.assignee.last_name}`;
              });
            }
            await this.$store
                .dispatch("auth/showUser", {
                  id: response?.user_id,
                })
                .then(async (res) => {
                  this.caseUser = res?.data ?? {};
                });
          });
      this.$nextTick(() => {
        this.$refs.previewOriginalRef?.reloadFiles?.();
      });
    },
    downloadFiles(array) {
      FileService.downloadFiles(array, this.$store);
    },
    addFile(event, jawType, fileType) {
      try {
        this.$store.commit("showLoader", true);
        const file = event.target.files[0];

        FileService.uploadFile(file, {visibility: 1}, 0, 0.33, this.productName === "dentaBridge")
            .then((response) => {
              this.$store.commit("showLoader", false);
              this.$store.dispatch(
                  `caseLists/${
                      fileType === "results" ? "saveResults" : "save-files"
                  }`,
                  {
                    caseId: this.$route.params.id,
                    ...(jawType == "upper"
                        ? {upper: response?.data[0]?.id}
                        : {lower: response?.data[0]?.id}),
                  }
              );
            })
            .finally(async () => {
              await this.loadItems();
              this.$store.commit("showLoader", false);
            });
      } catch (e) {
      }
    },
    closePreviewResultModal() {
      this.showPreviewModal = false;
    },
    handlePreviewResultClick(array, jawType) {
      this.file = array;
      this.previewJawType = jawType;
      this.showPreviewModal = true;
    },
    async setRatingValue(event, jawType) {
      await this.$store.dispatch("caseLists/saveRating", {
        caseId: this.$route.params.id,
        ...(jawType === "upper"
            ? {upperCaseRating: event}
            : {lowerCaseRating: event}),
      });
    },
    async updateCase() {

      try {
        this.$store.commit("showLoader", true);

        // Upload 2D to 3D files if available
        let uploadedIds = {upperId: null, lowerId: null};
        if (this.$refs.previewOriginalRef) {
          uploadedIds = await this.$refs.previewOriginalRef.uploadData2DTo3D();
        }

        // Determine file IDs (uploaded or existing from form)
        const upperId = uploadedIds.upperId?.id || uploadedIds.upperId || this.form.files.upper;
        ;
        const lowerId = uploadedIds.lowerId?.id || uploadedIds.lowerId || this.form.files.lower;

        // If bite was scanned, mirror transforms so upper/lower share the same matrices
        if (this.form.jawsCorrectlyAligned && uploadedIds?.lower_matrixLocal?.reg) {
          const sameLocal = [...uploadedIds.lower_matrixLocal.reg];
          const sameWorld = [...(uploadedIds.lower_matrixWorld?.reg || [])];
          uploadedIds.upper_matrixLocal = {reg: [...sameLocal]};
          if (sameWorld.length) uploadedIds.upper_matrixWorld = {reg: [...sameWorld]};
          // keep rotations/translations identical as well (consumers sometimes read those)
          uploadedIds.upper_rotation = uploadedIds.lower_rotation;
          uploadedIds.upper_translation = uploadedIds.lower_translation;
          uploadedIds.upper_quaternion = uploadedIds.lower_quaternion;
          uploadedIds.upper_scale = uploadedIds.lower_scale;
        }

        // Prepare payload for saving files
        const payload = {
          caseId: this.$route.params.id,
          upper: upperId,
          lower: lowerId,
          upper_portal: upperId ?? null,
          lower_portal: lowerId ?? null,
          upper_rotation: uploadedIds?.upper_rotation,
          upper_translation: uploadedIds?.upper_translation,
          upper_matrixWorld: uploadedIds?.upper_matrixWorld,
          upper_quaternion: uploadedIds?.upper_quaternion,
          upper_scale: uploadedIds?.upper_scale,
          upper_matrixLocal: uploadedIds?.upper_matrixLocal,
          lower_rotation: uploadedIds?.lower_rotation,
          lower_translation: uploadedIds?.lower_translation,
          lower_matrixWorld: uploadedIds?.lower_matrixWorld,
          lower_quaternion: uploadedIds?.lower_quaternion,
          lower_scale: uploadedIds?.lower_scale,
          lower_matrixLocal: uploadedIds?.lower_matrixLocal,
        };

        // Save Files
        await this.$store.dispatch("caseLists/saveFiles", payload);

        await this.$nextTick();
        this.$store.commit("showLoader", true);
        // Replicate Case after successful update
        await this.replicateCase();
      } catch (error) {
        console.error("Error updating case:", error);
      } finally {
        this.$store.commit("showLoader", false);
      }
    },

    async deleteJaw(jaw) {
      const confirmed = await this.showConfirmationDialog({
        title: this.$t("doYouWantToCompletelyDeleteThisJaw"),
        subText: this.$t("yesDeleteIt"),
      });

      if (confirmed) {
        const payload = {
          caseId: this.$route.params.id,
          jaw: jaw,
        };

        this.$store.commit("showLoader", true);
        await this.$store
            .dispatch("caseLists/deleteJaw", payload)
            .finally(() => {
              this.$store.commit("showLoader", false);
              this.loadResults();
              this.loadItems();
            });
      }
    },
    async restoreJaw(jaw) {
      const confirmed = await this.showConfirmationDialog({
        title: this.$t("doYouWantToRestoreThisJaw"),
        subText: this.$t("yesRestoreIt"),
      });

      if (confirmed) {
        const payload = {
          caseId: this.$route.params.id,
          jaw: jaw,
        };

        this.$store.commit("showLoader", true);
        await this.$store
            .dispatch("caseLists/restoreJaw", payload)
            .finally(() => {
              this.$store.commit("showLoader", false);
              this.loadResults();
              this.loadItems();
            });
      }
    },
    handleConstructionInfoFileChange(event) {
      const file = event.target.files?.[0];
      if (!file) {
        this.constructionInfoFile = null;
        return;
      }

      const allowedExtensions = [".constructioninfo", ".xml", ".text", ".txt"];
      const fileName = file.name.toLowerCase();
      const isValid = allowedExtensions.some((ext) => fileName.endsWith(ext));

      if (!isValid) {
        event.target.value = "";
        this.constructionInfoFile = null;
        return;
      }

      this.constructionInfoFile = file;
    },
    async updateCaseData() {
      this.$refs.simpleRules.validate().then(async (success) => {
        if (success) {
          this.$store.commit("showLoader", true);
          await this.$nextTick();
          setTimeout(async () => {
            try {
              await this.$store.dispatch("caseLists/update", {
                id: this.$route.params.id,
                data: {
                  ...this.form,
                  assignee: this.form.assignee?.id ?? null,
                },
              });
              if (this.form.isApproved == true) {
                this.form.status = "done";
              }
              await this.loadItems();
              this.$store.commit("showLoader", false);
            } catch (e) {
              console.error(e);
            } finally {
              this.$store.commit("showLoader", false);
            }
          }, 0);
        }
      });
    },
    async handleFeedbackSubmit(feedback) {
      try {

        if (feedback.aiCorrect === false) {
          this.$store.commit("showLoader", true);
          const feedbackData = {
            caseId: this.$route.params.id,
            aiCorrect: feedback.aiCorrect,
            selectedTeeth: feedback.selectedTeeth,
            selectedProblems: feedback.selectedProblems,
          };
          await this.$store.dispatch("caseLists/saveCaseFeedback", feedbackData);
        }

      } catch (error) {
        console.error("Error saving feedback:", error);
      } finally {
        this.$store.commit("showLoader", false);
      }
    },
    isDentaWaxOrTemp(productName) {
      const translatedProductName = productTranslatorMixin.methods.translatedProductName;

      return (
        translatedProductName(productName, true) === 'shellTempDesign' ||
        translatedProductName(productName, true) === 'setupGuideForImplants'
      );
    }
  },
  // beforeRouteLeave(to, from, next) {
  //   this.unlockCase(); // async call is fine
  //   next(); // allow navigation
  // },
};
</script>

<style lang="scss" scoped>
#nprogress {
  position: relative;
  z-index: 9999999;
}

.white-color {
  color: white !important;
}

.vgt-responsive {
  overflow-x: visible !important;
}

.news-image {
  margin-top: 10px;

  img {
    width: 200px;
    max-width: 100%;
    object-fit: contain;
    border: 1px solid rgba(255, 255, 255, 0.2);
    padding: 5px;
    border-radius: 5px;
  }
}
</style>
